module.exports = {
  credsystem: {
    dark: {
      500: '#302D2D',
    },
    whatsAppGreen: '#25D366',
    light: {
      200: '#FDFDFD',
    },
    success: {
      300: '#2DDF89',
      500: '#7EAB7E',
    },
    error: {
      500: '#CD2D60',
    },
    gray: {
      500: '#838181',
    },
  },
};
